import { render, staticRenderFns } from "./DesignFoundationsIconography.vue?vue&type=template&id=4e4d92fe&scoped=true"
import script from "./DesignFoundationsIconography.vue?vue&type=script&lang=js"
export * from "./DesignFoundationsIconography.vue?vue&type=script&lang=js"
import style0 from "./DesignFoundationsIconography.vue?vue&type=style&index=0&id=4e4d92fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4d92fe",
  null
  
)

/* custom blocks */
import block0 from "./DesignFoundationsIconography.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports